export default {
  index: "Trang chủ",
  news: "Tin tức",
  signout: "Đăng xuất",
  find: "Phát hiện",
  confirmText: "Đồng ý",
  cancelText: "Hủy",
  login: {
    account: "Tài khoản",
    accountplaceholder: "Nhập tài khoản",
    password: "Mật khẩu",
    passwordplaceholder: "Nhập mật khẩu",
    sign: "Đăng nhập",
    register: "Đăng ký",
    forpassword: "Quên mật khẩu",
    emailplaceholder: "Nhập địa chỉ email",
    RegisterCodeText: "Nhập 4 mã kiểm chứng",
    RegisterEmailText: "Đã gửi mã kiểm chứng ",
    resend: "Gửi lại",
    previousStep: "Trước",
    nextStep: "Tiếp theo",
    setpassword: "Cài đặt mậu khẩu đăng nhập",
    setpasswordTip: "Mật khẩu phải là tổ hợp 6-9 chữ cái và số",
    signPassword: "Mật khẩu đăng nhập",
    resignPassword: "Nhập lại mật khẩu đăng nhập",
    resignPasswordConfirm: "Xác nhận mật khẩu lần nữa",
    confirm: "Xác nhận",
    sendRePasswordEmail: "Gửi thư cài đặt lại mật khẩu",
    resignPasswordSendSuccessText:
      "Đã gửi thư cài đặt lại mật khẩu, thao tác theo gợi ý",
    SetresignPasswordSuccessText: "Cài đặt mật khẩu đăng nhập thành công",
    toSign: "Vào đăng nhập",
    resend60s: "Sau 60s có thể gửi lại",
    emailTip: "Nhập địa chỉ email chính xác",
    vcode: "Mã kiểm chứng:",
    setpasswordtext: "Cài đặt mật khẩu",
    passwordTip: "Nhập mật khẩu chính xác",
    passwordErrorTip: "Mật khẩu không đúng",
    SetSuccessText: "Cài đặt thành công",
    inputaccpass: "Nhập mật khẩu tài khoản",
    emailReg: "Kiểm chứng thư điện tử và đăng ký",
    sresend: "sau có thể gửi lại"
  },
  product: {
    firm: "Nhà Phát Hành",
    download: "Tải Game",
    recharge: "Nạp Code",
    rechargeActivity: "Lịch sử nạp Code",
    introduction: "Giới thiệu",
    preview: "Xem trước",
    recentUpdates: "Cập nhật mới nhất",
    information: "Chi tiết",
    fileSize: "Kích thước file",
    version: "Phiên bản hiện tại",
    updateTime: "Thời gian cập nhật"
  },
  publishType: {
    0: "Các sự kiện đang diễn ra",
    1: "Các trò chơi đang phát hành",
    2: "Giới thiệu game hay"
  },
  gamelist: {
    allGame: "Tất cả game",
    hotGame: "Game hot",
    retract: "Thu gọn",
    more: "Chi tiết"
  },
  QRCode: {
    FindGame: "Mua Code Scode",
    follow: "",
    RecentRecharge: "Nạp nhanh",
    signreg: "Đăng nhập/Đăng ký",
    relatedGames: "Trò chơi liên quan",
    LoginBtnTextCont:
      "Sau khi đăng nhập có thể tìm kiếm lịch sử nạp Code để tiện nạp hơn",
    LoginUserInfo: "Bạn không có lịch sử nạp Code, mau nạp nhé"
  },
  reSetPassword: {
    SetresignPasswordSuccessText: "Sửa mật khẩu thành công, hãy đăng nhập"
  },
  setPassword: {
    settingPassword: "Cài đặt mật khẩu đăng nhập",
    settingNewPassword: "Cài đặt mật khẩu đăng nhập mới",
    passwordLimit: "Mật khẩu phải là tổ hợp từ 6-9 chữ cái và số",
    inpPassword: "Mật khẩu đăng nhập (phải điền)",
    rinpPassword: "Nhập lại mật khẩu đăng nhập (phải điền)",
    pwdtipnull: "Mật khẩu không thể để trống",
    pwdtip: "Mật khẩu không phù hợp yêu cầu",
    rpwdtip: "Mật khẩu nhập 2 lần không giống nhau"
  },
  feet: {
    title1:
      "Cổng game có bản quyền chính chủ, đã được kiểm duyệt trên Appstore và CHplay",
    title2:
      "Đăng ký tài khoản và đăng nhập Solaplay để liên kết nhân vật trong game, dùng kênh nạp chính thức từ Solaplay để nạp nhanh hơn",
    title3:
      "Nhận phúc lợi và thông tinh sự kiện mới nhất của trang chủ game mọi lúc mọi nơi",
    qrdown: "Tải bằng QR",
    download: "Tải miễn phí"
  },
  interact: {
    1: "Mạng không ổn định, vui lòng thử lại sau",
    2: "Đang yêu cầu",
    3: "Về trang đăng nhập",
    4: "Hệ thống khác thường, vui lòng thử lại sau",
    5: "Tài khoản không thể trống",
    6: "Mật mã không thể trống",
    7: "Đăng ký lại",
    8: "Ok",
    9: "Tài khoản không tồn tại",
    10: "Vào đăng nhập/Đăng ký",
    11: "Dịch vụ nạp game này do Scode cung cấp, hãy đăng nhập hoặc đăng ký tài khoản Scode",
    12: "Tải khoản chưa đăng nhập",
    13: "Không tìm được nhân vật",
    14: "Yêu cầu khác thường hãy thử lại sau",
    15: "Đăng nhập quá hạn, hãy đăng nhập lại",
    E502572099999: "Hệ thống khác thường",
    E502572000001: "Kiểm chứng chữ ký không được duyệt",
    E502572000002: "ACCESSTOKEN lặp lại",
    E502572000003: "Giải mã dữ liệu nhạy cảm lỗi",
    E502573000004: "Tham số yêu cầu sai",
    E502576000005: "Mã kiểm chứng sai",
    E502576000006: "Mật mã đăng nhập sai",
    E502572000007: "Không thể đăng nhập",
    E502576000008: "Tài khoản chưa đăng nhập",
    E502576000009: "Tài khoản này đã đăng ký, hãy trực tiếp đăng nhập",
    E502576000010: "Chưa đăng ký",
    E502576000011: "Liên kết thất bại hoặc không thể liên kết",
    E80000000001: "Mã chi trả sai",
    C301100000000: "Thành công",
    E301107100004: "đơn đặt không tồn tại",
    E301105100007: "đơn đặt thất bại",
    E301107100017: "Hệ thống bận, hãy thử lại sau",
    E301107100023: "đơn đặt này đã chi trả vui lòng không lặp lại chi trả",
    EC301105100007: "Mã kiểm chứng thất bại, hãy nhận lại mã kiểm chứng",
    EC01105100008: "Mã kiểm chứng sai, hãy nhập lại",
    "0000": "Giao dịch thành công",
    "0008": "Không có tài khoản này",
    "0002": "Trạng thái tài khoản khác thường",
    "9991": "Giao dịch vô hiệu, Text thông báo khác thường",
    "0014": "Merchant vô hiệu, người dùng không có tài khoản chi trả",
    "0007": "Mã đơn đặt lặp lại",
    "0006": "Hạn mức không đúng",
    "9999": "Phân phối hệ thống lỗi, không có tham số kiểm chứng mật mã",
    "0013": "Kiểm chứng mật mã thất bại",
    "0018": "Không có tài khoản này, tài khoản rút",
    "0010": "Trạng thái tài khoản khác thường, tài khoản rút",
    "0019": "Không có tài khoản này, tài khoản gửi",
    "0011": "Trạng thái tài khoản khác thường, tài khoản gửi",
    "0003": "Số dư không đủ",
    "0000": "Yêu cầu thành công",
    E202000200004: "Hệ thống lỗi",
    E200000000021: "Kiểm chứng tham số thất bại",
    E200000000017: "Khác thường"
  }
};



// WEBPACK FOOTER //
// ./src/language/vn.js